import { SkeletonBase } from "@unified-checkout/design-system";
import { Header } from "../Header";
import styles from "../business-profile.module.scss";

export const BusinessProfileSkeleton = () => {
  return (
    <div className={styles["business-profile"]}>
      <Header />
      <div className={styles["business-profile__skeleton"]}>
        <div className={styles["business-profile__skeleton__section"]}>
          <div className={styles["business-profile__skeleton__section__label"]}>
            <SkeletonBase height="1.5rem" width="120px" />
          </div>
          <div className={styles["business-profile__skeleton__section__form"]}>
            <div className={styles["business-profile__skeleton__section__form__content"]}>
              <div className={styles["business-profile__skeleton__section__form__logo-skeleton"]}>
                <div className={styles["business-profile__skeleton__section__form__logo-skeleton__text"]}>
                  <div style={{ marginBottom: '0.5rem' }}>
                    <SkeletonBase height="1.25rem" width="80px" />
                  </div>
                  <SkeletonBase height="1rem" width="200px" />
                </div>
                <div className={styles["business-profile__skeleton__section__form__logo-skeleton__image"]}>
                  <SkeletonBase height="64px" width="64px" />
                </div>
              </div>
              <div className={styles["business-profile__skeleton__section__form__row"]}>
                <SkeletonBase height="3.5rem" />
                <SkeletonBase height="3.5rem" />
              </div>
              <div className={styles["business-profile__skeleton__section__form__row"]}>
                <SkeletonBase height="3.5rem" />
                <SkeletonBase height="3.5rem" />
                <SkeletonBase height="3.5rem" />
              </div>
            </div>
          </div>
        </div>

        <div className={styles["business-profile__skeleton__section"]}>
          <div className={styles["business-profile__skeleton__section__label"]}>
            <SkeletonBase height="1.5rem" width="120px" />
          </div>
          <div className={styles["business-profile__skeleton__section__form"]}>
            <div className={styles["business-profile__skeleton__section__form__content"]}>
              <SkeletonBase height="3.5rem" />
              <SkeletonBase height="3.5rem" />
              <SkeletonBase height="3.5rem" />
              <SkeletonBase height="3.5rem" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
